import { Helmet } from "react-helmet";

interface SEOProps {
  title: string;
  description: string;
  path: string; // e.g. "/about"
  image?: string;
  type?: "website" | "article";
}

const SITE = "https://samranrealestate.com";
const DEFAULT_IMAGE =
  "https://pub-bb2e103a32db4e198524a2e9ed8f35b4.r2.dev/a23f56d8-b5b5-47d8-9028-265e55ccd70d/id-preview-d9660b83--1cfb01a5-8bab-447d-8353-975968ac89cc.lovable.app-1775148288989.png";

/**
 * Per-route SEO tags. Overrides the sitewide defaults set in index.html
 * so each page has a unique title, description, canonical, and og:* URL.
 */
const SEO = ({ title, description, path, image, type = "website" }: SEOProps) => {
  const url = `${SITE}${path}`;
  const img = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
};

export default SEO;
